"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthActionTypes = void 0;
var AuthActionTypes;
(function (AuthActionTypes) {
    AuthActionTypes["LOGIN"] = "LOGIN";
    AuthActionTypes["FORGOT"] = "FORGOT";
    AuthActionTypes["LOGOUT"] = "LOGOUT";
    AuthActionTypes["RESET"] = "RESET";
})(AuthActionTypes || (exports.AuthActionTypes = AuthActionTypes = {}));
//# sourceMappingURL=types.js.map